var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 10V14C15 15.1046 14.1046 16 13 16H2C0.89543 16 0 15.1046 0 14V3C0 1.89543 0.89543 1 2 1H6V3H2V14H13V10H15ZM13.9971 3.41421L7.70421 9.70711L6.28999 8.29289L12.5829 2H8.9971V0H15.9971V7H13.9971V3.41421Z",
    fill: "#D7EED5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalLink);
export default __webpack_public_path__ + "static/media/modal-link.a65e2e7b7e4c319b6e2f311dcf2eb074.svg";
export { ForwardRef as ReactComponent };